import {
  DOMAIN_PREFIX,
  domainCode,
  LANGUAGE_ENUMS,
  LANGUAGE_VALUE,
  TLANGUAGE_VALUE,
} from '../../../constants/staticPageConstants';
import { getCalculatorTheme } from './utils/theme-detector';
import { processURL } from '../../../utils/static-pages/urlProcessor';
import { If } from '../../Atoms/Conditionals';
import DonutChart from '../../Common/Donut';
import { addCommasToNumber } from '../../Utils/CommonUtils';
import {
  CATEGORY_PROPS,
  ISINGLE_POST,
  ISOCIAL_MEDIA,
} from '../../cms/layout/types';
import { decodeHtml } from '../../cms/layout/util';
import { componentMap } from '../DescriptionComp';
import calculatorsService from './Services/calculators.service';
import { Calculator } from './components/Calculator';
import { SelectBox } from './components/form-components/CheckBox';
import { TextInput } from './components/form-components/InputBox';
import { DateInput } from './components/form-components/InputDate';
import InputRangeSlider from './components/form-components/InputRangeSlider';
import { RadioButton } from './components/form-components/RadioButton';
import { SelectInput } from './components/form-components/SelectBox';
import { ToggleButton } from './components/form-components/ToggleButton';
import { SEVENTH_PAY_COMMISSION_FORMULA } from './formulas/7th-pay-formula';
import { APY_CALCULATOR_FORMULA } from './formulas/apy-formula/apy-formula';
import { CAGR_FORMULA } from './formulas/cagr-formula';
import { COMPOUND_INTEREST_FORMULA } from './formulas/compound-interest-formula';
import { DEPRECIATION_FORMULA } from './formulas/depreciation-formula/depreciation-formula';
import { DISCOUNT_FORMULA } from './formulas/discount-formula';
import { DIVIDEND_CALCULATOR_FORMULA } from './formulas/dividend-formula';
import { DOWN_PAYMENT_FORMULA } from './formulas/dp-formula';
import { EDUCATION_INVESTMENT_FORMULA } from './formulas/education-loan-formula';
import { PAY_COMMISSION_FORMULA } from './formulas/eigth-pay-formula';
import { EMI_FORMULA } from './formulas/emi-formula/emi-formula';
import { EMI_MONTHLY_DETAILS } from './formulas/emi-formula/monthlyEmi';
import { EPF_FORMULA } from './formulas/epf-formula';
import { EXPERIENCE_CALCULATOR_FORMULA } from './formulas/experience-formula';
import { FD_FORMULA } from './formulas/fd-formula';
import { FLAT_AND_REDUCING_RATE_FORMULA } from './formulas/flat-reducing-rate-formula';
import { FUTURE_VALUE_CALCULATOR_FORMULA } from './formulas/future-value-formula';
import { GOALPLANNER_FORMULA } from './formulas/goalplanner-formula';
import { GPF_FORMULA } from './formulas/gpf-formula';
import { GRATUITY_FORMULA } from './formulas/gratuity-formula';
import { GST_FORMULA } from './formulas/gst-formula';
import { HLP_FORMULA } from './formulas/hlp-formula';
import { HOME_LOAN_ELIGIBILITY_FORMULA } from './formulas/home-load-eligibility-formula';
import { HRA_FORMULA } from './formulas/hra-formula';
import { INFLATION_CALCULATOR_FORMULA } from './formulas/inflation-formula';
import { ELSS_CALCULATOR_FORMULA } from './formulas/investment-calculator/elss-calculator';
import { KVP_FORMULA } from './formulas/kvp-formula';
import { LEASE_FORMULA } from './formulas/lease-formula';
import { LEAVE_ENCASHMENT_FORMULA } from './formulas/leaveencash';
import { LTCG_FORMULA } from './formulas/ltcg-formula/ltcg-formula';
import { LUMPSUM_CALCULATOR_FORMULA } from './formulas/lumpsum-formula';
import { MARGIN_FORMULA } from './formulas/margin-formula';
import { MARRIAGE_FORMULA } from './formulas/marriage-formula';
import { MUTUAL_FUND_FORMULA } from './formulas/mf-formula';
import { MORTGAGE_FORMULA } from './formulas/mortgage-formula';
import { NW_FORMULA } from './formulas/networth-formula/nw-formula';
import { NPS_FORMULA } from './formulas/nps-formula';
import { NPV_FORMULA } from './formulas/npv-formula';
import { NSC_CALCULATOR_FORMULA } from './formulas/nsc-formula';
import { PAYBACK_FORMULA } from './formulas/payback-formula';
import { PERSONAL_LOAN_ELIGIBILITY_FORMULA } from './formulas/personal-loan-eligibility-formula';
import { POMIS_FORMULA } from './formulas/pomis-formula';
import { PPF_FORMULA } from './formulas/ppf-formula';
import { PRESENT_VALUE_FORMULA } from './formulas/pv-formula';
import { RD_FORMULA } from './formulas/rd-formula';
import { RETIREMENT_FORMULA } from './formulas/retirement-formula';
import { REVERSE_GST_FORMULA } from './formulas/reverse-gst-formula';
import { ROI_FORMULA } from './formulas/roi-formula';
import { SALARY_CALCULATOR_FORMULA } from './formulas/salary-formula';
import { SALARYTAKE_FORMULA } from './formulas/salary-formula/salarytake-formula';
import { SAVINGS_FORMULA } from './formulas/savings-formula';
import { SBIANNUITY_FORMULA } from './formulas/sbi-annuity';
import { SCSS_FORMULA } from './formulas/scss-formula';
import { SIMPLE_COMPOUND_INTEREST_FORMULA } from './formulas/simple-compound-interest-formula';
import { SIP_FORMULA } from './formulas/sip-formula';
import { SST_FORMULA } from './formulas/sst-formula';
import { SSY_FORMULA } from './formulas/ssy-formula';
import { STEP_UP_SIP_FORMULA } from './formulas/step-up-sip-formula';
import { STOCK_FORMULA } from './formulas/stock-formula';
import { SWP_FORMULA } from './formulas/swp-formula';
import { TAX_SAVING_FORMULA } from './formulas/tax-saving-formula';
import { TDS_FORMULA } from './formulas/tds-formula';
import { TDS_INTEREST_RATE_CALCULATOR_FORMULA } from './formulas/tds-interest-formula';
import { UPS_FORMULA } from './formulas/ups-formula';
import { VAT_UAE_FORMULA } from './formulas/vat-uae-formula';
import {
  IAccordionField,
  IButtonField,
  ICalculatedResult,
  ICALCULATOR,
  ICtaField,
  IField,
  IGraphField,
  IOutputField,
  ISelectField,
  TCALCULATOR_FIELD_TYPE,
} from './types';
import { GSTOutputComponent } from './components/GSTOutputComponent';
import { Button, ButtonVariants } from '../../Atoms/Button';
import { ButtonWithAnchor } from '../../income-tax/page-sections/hero-section/sticky-button';

//@ts-ignore
export const getFormula = (name: string, formData) => {
  switch (name) {
    case 'FD_FORMULA':
      return FD_FORMULA({ ...formData });
    case 'ELIGIBILITY_FORMULA':
      return HOME_LOAN_ELIGIBILITY_FORMULA({ ...formData });
    case 'EMI_FORMULA':
      return EMI_FORMULA({ ...formData });
    case 'EMI_MONTHLY_DETAILS':
      return EMI_MONTHLY_DETAILS({ ...formData });
    case 'PPF_FORMULA':
      return PPF_FORMULA({ ...formData });
    case 'SIP_FORMULA':
      return SIP_FORMULA({ ...formData });
    case 'EDUCATION_INVESTMENT_FORMULA':
      return EDUCATION_INVESTMENT_FORMULA({ ...formData });
    case 'RD_FORMULA':
      return RD_FORMULA({ ...formData });
    case 'DISCOUNT_FORMULA':
      return DISCOUNT_FORMULA({ ...formData });
    case 'LUMPSUM_CALCULATOR_FORMULA':
      return LUMPSUM_CALCULATOR_FORMULA({ ...formData });
    case 'FUTURE_VALUE_CALCULATOR_FORMULA':
      return FUTURE_VALUE_CALCULATOR_FORMULA({ ...formData });
    case 'COMPOUND_INTEREST_FORMULA':
      return COMPOUND_INTEREST_FORMULA({ ...formData });
    case 'NSC_CALCULATOR_FORMULA':
      return NSC_CALCULATOR_FORMULA({ ...formData });
    case 'LEASE_FORMULA':
      return LEASE_FORMULA({ ...formData });
    case 'HLP_FORMULA':
      return HLP_FORMULA({ ...formData });
    case 'STOCK_FORMULA':
      return STOCK_FORMULA({ ...formData });
    case 'SWP_FORMULA':
      return SWP_FORMULA({ ...formData });
    case 'SAVINGS_FORMULA':
      return SAVINGS_FORMULA({ ...formData });
    case 'MORTGAGE_FORMULA':
      return MORTGAGE_FORMULA({ ...formData });
    case 'DOWN_PAYMENT_FORMULA':
      return DOWN_PAYMENT_FORMULA({ ...formData });
    case 'SIMPLE_COMPOUND_INTEREST_FORMULA':
      return SIMPLE_COMPOUND_INTEREST_FORMULA({ ...formData });
    case 'CAGR_FORMULA':
      return CAGR_FORMULA({ ...formData });
    case 'PRESENT_VALUE_FORMULA':
      return PRESENT_VALUE_FORMULA({ ...formData });
    case 'GRATUITY_FORMULA':
      return GRATUITY_FORMULA({ ...formData });
    case 'KVP_FORMULA':
      return KVP_FORMULA({ ...formData });
    case 'POMIS_FORMULA':
      return POMIS_FORMULA({ ...formData });
    case 'PAYBACK_FORMULA':
      return PAYBACK_FORMULA({ ...formData });
    case 'SCSS_FORMULA':
      return SCSS_FORMULA({ ...formData });
    case 'ROI_FORMULA':
      return ROI_FORMULA({ ...formData });
    case 'ELSS_CALCULATOR_FORMULA':
      return ELSS_CALCULATOR_FORMULA({ ...formData });
    case 'MUTUAL_FUND_FORMULA':
      return MUTUAL_FUND_FORMULA({ ...formData });
    case 'PAY_COMMISSION_FORMULA':
      return PAY_COMMISSION_FORMULA({ ...formData });
    case 'INFLATION_CALCULATOR_FORMULA':
      return INFLATION_CALCULATOR_FORMULA({ ...formData });
    case 'APY_CALCULATOR_FORMULA':
      return APY_CALCULATOR_FORMULA({ ...formData });
    case 'DIVIDEND_CALCULATOR_FORMULA':
      return DIVIDEND_CALCULATOR_FORMULA({ ...formData });
    case 'SALARY_CALCULATOR_FORMULA':
      return SALARY_CALCULATOR_FORMULA({ ...formData });
    case 'EXPERIENCE_CALCULATOR_FORMULA':
      return EXPERIENCE_CALCULATOR_FORMULA({ ...formData });
    case 'NPV_FORMULA':
      return NPV_FORMULA({ ...formData });
    case 'SBIANNUITY_FORMULA':
      return SBIANNUITY_FORMULA({ ...formData });
    case 'SSY_FORMULA':
      return SSY_FORMULA({ ...formData });
    case 'FLAT_AND_REDUCING_FORMULA':
      return FLAT_AND_REDUCING_RATE_FORMULA({ ...formData });
    case 'PERSONAL_LOAN_ELIGIBILITY_FORMULA':
      return PERSONAL_LOAN_ELIGIBILITY_FORMULA({ ...formData });
    case 'SEVENTH_PAY_COMMISSION_FORMULA':
      return SEVENTH_PAY_COMMISSION_FORMULA({ ...formData });
    case 'STEP_UP_SIP_FORMULA':
      return STEP_UP_SIP_FORMULA({ ...formData });
    case 'TDS_INTEREST_CALCULATOR_FORMULA':
      return TDS_INTEREST_RATE_CALCULATOR_FORMULA({ ...formData });
    case 'SALARYTAKE_FORMULA':
      return SALARYTAKE_FORMULA({ ...formData });
    case 'MARRIAGE_FORMULA':
      return MARRIAGE_FORMULA({ ...formData });
    case 'NW_FORMULA':
      return NW_FORMULA({ ...formData });
    case 'GPF_FORMULA':
      return GPF_FORMULA({ ...formData });
    case 'TAX_SAVING_FORMULA':
      return TAX_SAVING_FORMULA({ ...formData });
    case 'DEPRECIATION_FORMULA':
      return DEPRECIATION_FORMULA({ ...formData });
    case 'MARGIN_FORMULA':
      return MARGIN_FORMULA({ ...formData });
    case 'EPF_FORMULA':
      return EPF_FORMULA({ ...formData });
    case 'NPS_FORMULA':
      return NPS_FORMULA({ ...formData });
    case 'GOALPLANNER_FORMULA':
      return GOALPLANNER_FORMULA({ ...formData });
    case 'RETIREMENT_FORMULA':
      return RETIREMENT_FORMULA({ ...formData });
    case 'LTCG_FORMULA':
      return LTCG_FORMULA({ ...formData });
    case 'SST_FORMULA':
      return SST_FORMULA({ ...formData });
    case 'LEAVE_ENCASHMENT_FORMULA':
      return LEAVE_ENCASHMENT_FORMULA({ ...formData });
    case 'TDS_FORMULA':
      return TDS_FORMULA({ ...formData });
    case 'VAT_UAE_FORMULA':
      return VAT_UAE_FORMULA({ ...formData });
    case 'UPS_FORMULA':
      return UPS_FORMULA({ ...formData });
    case 'HRA_FORMULA':
      return HRA_FORMULA({ ...formData });
    case 'GST_FORMULA':
      return GST_FORMULA({ ...formData });
    case 'REVERSE_GST_FORMULA':
      return REVERSE_GST_FORMULA({ ...formData });
    case 'default':
      return { ...formData };
  }
  return { ...formData };
};

export const getOrderedFields = (
  fields: TCALCULATOR_FIELD_TYPE | undefined
) => {
  if (!fields) return {};

  const fieldArray = Object.entries(fields);
  const sortedArray = fieldArray.sort(([, a], [, b]) => {
    return a.uiOrder - b.uiOrder;
  });
  const sortedFieldsObject = sortedArray.reduce(
    (acc, [key, value]) => ({
      ...acc,
      [key]: value,
    }),
    {}
  );
  return sortedFieldsObject;
};

export const renderCalculator = (calculatorData: ICALCULATOR | undefined) => {
  if (!calculatorData) return null;
  const sortedFields = getOrderedFields(calculatorData?.fields);
  const sortedCalcField = {
    ...calculatorData,
    ...sortedFields,
  };
  const shouldRenderCalculator = Object.keys(sortedFields).length > 0;

  return shouldRenderCalculator ? (
    <Calculator calcData={sortedCalcField as ICALCULATOR} />
  ) : null;
};

export function getDefaultValues(
  fields: Record<string, IField>,
  targetType: string
) {
  const obj: Record<string, string | number> = {};
  Object.entries(fields).forEach(([fieldKey, fieldData]) => {
    if (fieldData.section === targetType) {
      obj[fieldKey] = fieldData.value || '';
    }
  });

  return obj;
}

export function getFieldsByType(
  fields: TCALCULATOR_FIELD_TYPE,
  targetType: string
) {
  const result: TCALCULATOR_FIELD_TYPE = {};

  for (const fieldKey in fields) {
    const fieldData = fields[fieldKey];
    if (fieldData?.section === targetType) {
      result[fieldKey] = fieldData;
    }
  }

  return result;
}

export function isDropdownOrRadioField(
  fields: TCALCULATOR_FIELD_TYPE,
  targetType: string
) {
  const result: TCALCULATOR_FIELD_TYPE = {};

  for (const fieldKey in fields) {
    const fieldData = fields[fieldKey];
    if (
      fieldData &&
      'options' in fieldData &&
      fieldData.section === targetType &&
      fieldData.toggleVisibility &&
      (fieldData.type === 'dropdown' ||
        fieldData.type === 'radio' ||
        fieldData.type === 'checkbox' ||
        fieldData.type === 'toggle')
    ) {
      result[fieldKey] = fieldData;
    }
  }

  return result;
}

export function getToggleVisibilityFields(fields: TCALCULATOR_FIELD_TYPE) {
  const result: TCALCULATOR_FIELD_TYPE = {};

  for (const fieldKey in fields) {
    const fieldData = fields[fieldKey];
    if (
      fieldData &&
      'options' in fieldData &&
      fieldData.toggleVisibility &&
      (fieldData.type === 'dropdown' ||
        fieldData.type === 'radio' ||
        fieldData.type === 'checkbox' ||
        fieldData.type === 'toggle')
    ) {
      result[fieldKey] = fieldData;
    }
  }

  return result;
}

export const getGraphData = (
  fieldData: IGraphField,
  calculatedResult: Record<string, string | number>
) => {
  const data = fieldData.data;
  data.forEach((item) => {
    item.y = Number(calculatedResult[item.yCalc]);
  });
  return data;
};

interface IRENDER_CALC_COMPONENT {
  title?: string;
  fieldKey: string;
  fieldData:
    | IField
    | IOutputField
    | IGraphField
    | IAccordionField
    | ISelectField
    | IButtonField;
  handleInputChange: (fieldName: string, value: string | number) => void;
  formData: Record<string, string | number>;
  calculatedResult: ICalculatedResult;
  calculatorFields?: TCALCULATOR_FIELD_TYPE;
}

export const RenderCalculatorComponent = ({
  fieldKey,
  fieldData,
  handleInputChange,
  formData,
  calculatedResult,
  calculatorFields,
}: IRENDER_CALC_COMPONENT & {
  calculatorFields?: TCALCULATOR_FIELD_TYPE;
}): JSX.Element => {
  // Get theme configuration if calculator fields are provided
  const theme = calculatorFields ? getCalculatorTheme(calculatorFields) : null;

  switch (fieldData.type) {
    case 'number':
      return (
        <TextInput
          warning={calculatedResult?.warning || ''}
          warningText={fieldData?.warningText || ''}
          id={fieldKey}
          label={fieldData.title}
          type={fieldData.type}
          onTextChangeFn={(e) => handleInputChange(fieldKey, e.target.value)}
          value={fieldData.value || ''}
          onBlurFn={() => {}}
          placeholder={fieldData.placeholder || ''}
          showLabel={true}
          info={fieldData.info}
          prefix={fieldData.prefix}
          suffix={fieldData.suffix}
          min={Number(fieldData.min)}
          max={Number(fieldData.max)}
          disabled={fieldData.disabled}
          hidden={fieldData.hide}
          styles={fieldData.className}
          bottomMargin={theme ? theme.behavior.bottomMargin : true}
          labelClass={theme?.behavior.labelClass}
        />
      );

    case 'slider':
      return (
        <InputRangeSlider
          warning={calculatedResult?.warning || ''}
          warningText={fieldData?.warningText || ''}
          label_text={fieldData.title}
          min_value={Number(fieldData.min)}
          max_value={Number(fieldData.max)}
          default_value={Number(formData[fieldKey] || fieldData.value)}
          step_value={fieldData.stepValue}
          getValue={(e) => handleInputChange(fieldKey, e)}
          suffix={fieldData.suffix}
          hidden={fieldData.hide}
          addCommas={fieldData.addCommas}
          onChange={(e) => handleInputChange(fieldKey, e.target.value)}
        />
      );
    case 'dropdown':
      return (
        <SelectInput
          id={fieldKey}
          label={fieldData.title}
          value={fieldData.value || ''}
          optionsArray={(fieldData as ISelectField).options}
          placeholder="Select an option"
          showLabel={true}
          onChange={handleInputChange}
          hidden={fieldData.hide}
          labelClass={theme?.behavior.labelClass}
          bottomMargin={theme ? theme.behavior.bottomMargin : true}
        />
      );
    case 'radio':
      return (
        <RadioButton
          id={fieldKey}
          label={fieldData.title}
          onChange={(e) => handleInputChange(fieldKey, e.target.value)}
          value={formData[fieldKey] || fieldData.value || ''}
          showLabel={true}
          optionsArray={(fieldData as ISelectField).options}
          parentClass={fieldData.className}
        />
      );
    case 'checkbox':
      return (
        <SelectBox
          id={fieldKey}
          label={fieldData.title}
          onChange={handleInputChange}
          value={fieldData.value || ''}
          showLabel={true}
        />
      );
    case 'toggle':
      return (
        <ToggleButton
          id={fieldKey}
          label={fieldData.title}
          onChange={(fieldName, value) => handleInputChange(fieldName, value)}
          value={String(formData[fieldKey] || fieldData.value || '')}
          showLabel={true}
          options={(fieldData as ISelectField).options}
          hidden={fieldData.hide}
        />
      );
    case 'output':
      return (
        <div
          className={`border-b ${fieldData.hide ? 'hidden' : ''} ${
            fieldData.className
          }`}
        >
          <div className="flex justify-between items-center gap-2 py-2 px-1">
            <div
              className={`text-base ${
                fieldData.className?.includes('font-bold')
                  ? 'font-bold'
                  : 'font-medium'
              }`}
            >
              {fieldData.title}
            </div>
            <div
              className={`text-base ${
                fieldData.className?.includes('font-bold')
                  ? 'font-bold'
                  : 'font-medium'
              } whitespace-nowrap`}
            >
              <span>
                {fieldData.prefix?.enabled ? fieldData.prefix?.icon : ''}
              </span>
              <span>{addCommasToNumber(calculatedResult[fieldKey], 2)}</span>
              <span>{fieldData.suffix ? fieldData.suffix : ''}</span>
            </div>
          </div>
          <If condition={!!fieldData.description}>
            <div className="text-s-14 font-medium text-[#9092A3] pl-1 pb-2">
              {fieldData.description}
            </div>
          </If>
        </div>
      );
    case 'description':
      return (
        <div
          id={fieldKey}
          className={`py-2 px-1 border-b text-base font-bold ${
            fieldData.hide ? 'hidden' : ''
          }`}
          dangerouslySetInnerHTML={{
            __html: decodeHtml(
              replacePlaceholders(fieldData.value || '', calculatedResult)
            ),
          }}
        ></div>
      );
    case 'outputWithoutGraph':
      return (
        <div className={fieldData.hide ? 'hidden' : ''}>
          <div className="flex justify-between items-center py-2">
            <div className="text-base font-medium text-gray-700">
              {fieldData.title}
            </div>
            <div
              className={`text-base font-bold ${
                (fieldData as IOutputField).isValueBlue ? 'text-blue-350' : ''
              }`}
            >
              <span>
                {fieldData.prefix && fieldData.prefix.enabled
                  ? fieldData.prefix.icon
                  : ''}
              </span>
              <span>{addCommasToNumber(calculatedResult[fieldKey], 2)}</span>
              <span>{fieldData.suffix ? fieldData.suffix : ''}</span>
            </div>
          </div>
          <hr
            className={`my-1 border-gray-200 ${
              fieldData.title === '' || calculatedResult[fieldKey] === ''
                ? 'hidden'
                : ''
            }`}
          />
        </div>
      );
    case 'stringOutputWithoutGraph':
      return (
        <div className={fieldData.hide ? 'hidden' : ''}>
          <div className="flex justify-between items-center py-2">
            <div className="text-base font-medium text-gray-700">
              {fieldData.title}
            </div>
            <div
              className={`text-base font-bold ${
                (fieldData as IOutputField).isValueBlue ? 'text-blue-350' : ''
              }`}
            >
              <span>{String(calculatedResult[fieldKey])}</span>
            </div>
          </div>
        </div>
      );
    case 'graph':
      return (
        <div className="mb-4 sm:mb-3">
          <DonutChart
            data={[
              ...getGraphData(fieldData as IGraphField, {
                ...calculatedResult,
                ...formData,
              }),
            ]}
          />
        </div>
      );

    case 'date':
      return (
        <DateInput
          id={fieldKey}
          label={fieldData.title}
          onDateChangeFn={(e) => handleInputChange(fieldKey, e.target.value)}
          onBlurFn={() => {}}
          value={fieldData.value || undefined}
          showLabel={true}
          minDateLimit={fieldData.minDateLimit} // hides the dates before a given date
          maxDateLimit={fieldData.maxDateLimit} // hides the datees after a given date
          type={fieldData.type}
          disabled={fieldData.disabled}
          hidden={fieldData.hide}
          formData={formData} // mandatory in case greaterThanDateComponent or lesserThanDateComponent are used
          isLesserThanToday={fieldData.isLesserThanToday}
          isGreaterThanToday={fieldData.isGreaterThanToday}
          greaterThanDateComponent={fieldData.greaterThanDateComponent}
          lesserThanDateComponent={fieldData.lesserThanDateComponent}
        />
      );
    case 'content': {
      const Component =
        fieldData.component && componentMap[fieldData.component];
      return (
        <div className={`p-6 ${fieldData.className}`}>
          {Component ? <Component /> : <></>}
        </div>
      );
    }
    case 'gstOutput':
      return (
        <GSTOutputComponent
          fieldKey={fieldKey}
          fieldData={fieldData as IOutputField}
          formData={formData}
          calculatedResult={calculatedResult}
        />
      );

    case 'button':
      return (
        <div className="w-full flex">
          <Button
            variant={ButtonVariants.bluefilled}
            rounded="md"
            onClick={() =>
              window.open(
                (fieldData as IButtonField).redirectUrl,
                (fieldData as IButtonField).target
              )
            }
            className="mt-10 w-full"
          >
            {(fieldData as IButtonField).text}
          </Button>
        </div>
      );

    case 'cta': {
      const ctaData = fieldData as ICtaField;
      const isHidden = fieldData.hide === true;

      if (!ctaData.ctaLink || !ctaData.ctaText) return <div></div>;

      return (
        <div className={`w-full mt-4 mb-3 ${isHidden ? 'hidden' : ''}`}>
          <ButtonWithAnchor
            buttonText={ctaData.ctaText}
            buttonLink={ctaData.ctaLink}
            trackLabel="calculator_cta"
            buttonVariant={ButtonVariants.bluefilled}
            target="_blank"
            className="w-full"
          />
        </div>
      );
    }

    default:
      return <div></div>;
  }
};

export const replacePlaceholders = (
  text: string,
  values: Record<string, string>
) => {
  if (!text) return '';

  let result = text;
  Object.keys(values).forEach((key) => {
    const placeholder = '${' + key + '}';
    if (result.includes(placeholder)) {
      result = result.split(placeholder).join(values[key]);
    }
  });

  return result;
};

export const isCalculatorPage = (category: CATEGORY_PROPS | null): boolean => {
  if (!category) {
    return false;
  }

  if (category.slug === 'calculators') {
    return true;
  }

  return isCalculatorPage(category.parent);
};

export const getCalculatorJson = async (htmlString: string) => {
  if (!htmlString) return null;

  const regex = /RC-CALCULATOR-\d+/g;
  const matches = htmlString.match(regex);

  if (!matches) return null;

  let calcData;
  for (const id of matches) {
    calcData = await calculatorsService.getSingleCalculator(id);
  }

  return calcData;
};

export const getCalculatorPageUrl = (data: ISINGLE_POST) => {
  const LANGUAGE = LANGUAGE_VALUE[
    data?.language as TLANGUAGE_VALUE
  ] as LANGUAGE_ENUMS;
  const pageURL = processURL(data.permalink, LANGUAGE, data.domain);

  let CURR_PAGE_URL = `https://www.${
    DOMAIN_PREFIX[data.domain]?.host
  }/${pageURL}`;

  if (data.domain === domainCode.cleartaxIn) {
    CURR_PAGE_URL = `https://cleartax.in/s/${pageURL}`;
  }
  return { CURR_PAGE_URL, LANGUAGE };
};

export const getSocialMediaData = ({
  linkedin,
  facebook,
  twitter,
  whatsapp,
}: ISOCIAL_MEDIA): Array<{
  name: string;
  link: string;
  icon: string;
  action?: string;
}> => {
  const data = [
    {
      name: 'whatsapp',
      link: whatsapp || '',
      icon: 'https://assets.clear.in/cleartax/images/1733554825_whatsapp.png',
      action: 'share/whatsapp/share',
    },
    {
      name: 'linkedIn',
      link: linkedin || '',
      icon: 'https://assets.clear.in/cleartax/images/1733554652_linkedinlogo.png',
    },
    {
      name: 'facebook',
      link: facebook || '',
      icon: 'https://assets.clear.in/cleartax/images/1707681007_icons8fb1.png',
    },
    {
      name: 'twitter',
      link: twitter || '',
      icon: 'https://assets.clear.in/cleartax/images/1733555092_x.png',
    },
  ];
  return data;
};

export const getImageForCalculator = (link: string) => {
  const linkAndImageMap: Record<string, string> = {
    'fd': 'https://assets.clear.in/cleartax/images/1704872079_calcimage.png',
    'sip': 'https://assets.clear.in/cleartax/images/1707994659_sip.png',
    'rd': 'https://assets.clear.in/cleartax/images/1707994650_rd.png',
    'home-loan':
      'https://assets.clear.in/cleartax/images/1707994628_homeloan.png',

    'ppf': 'https://assets.clear.in/cleartax/images/1707994638_ppf.png',
    'nsc': 'https://assets.clear.in/cleartax/images/1707994668_nsc.png',
    'scss': 'https://assets.clear.in/cleartax/images/1707994682_scss.png',
    'pomis': 'https://assets.clear.in/cleartax/images/1707994696_pomis.png',
    'kvp': 'https://assets.clear.in/cleartax/images/1707994707_kvp.png',
    'compound-interest':
      'https://assets.clear.in/cleartax/images/1707994720_compoundinterest.png',
    'emi': 'https://assets.clear.in/cleartax/images/1707994619_emi.png',
  };

  let imageUrl: string | undefined;

  // Check if the link contains any of the keys in linkAndImageMap
  for (const key in linkAndImageMap) {
    if (link.includes(key)) {
      imageUrl = linkAndImageMap[key];
      break;
    }
  }
  return (
    imageUrl ||
    'https://assets.clear.in/cleartax/images/1704872079_calcimage.png'
  );
};
